import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b42369f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "items-in-line" }

import { Swiper, SwiperSlide } from 'swiper/vue';
// eslint-disable-next-line import/no-unresolved
import { SwiperModule } from 'swiper/types/shared';
import { onMounted, Ref, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'GallerySwiper',
  props: {
    swiper: {},
    modules: {},
    slides: {},
    widthItem: { default: 120 },
    spaceBetween: { default: 5 }
  },
  setup(__props: any) {

const props = __props;

const prev = ref(null);
const next = ref(null);
const itemsToShow: Ref<number> = ref(1);

onMounted(() => {
  setTimeout(() => {
    const elem = document.getElementById(`thumbnails-swiper-${props.swiper}`);
    let width: undefined | number = undefined;

    if (elem) {
      width = elem.offsetWidth;
      itemsToShow.value = width / props.widthItem;
    }
  }, 100);
});

return (_ctx: any,_cache: any) => {
  const _component_base_image = _resolveComponent("base-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "prev",
      ref: prev,
      class: "swiper-button-prev"
    }, null, 512),
    _createVNode(_unref(Swiper), {
      id: `thumbnails-swiper-${_ctx.swiper}`,
      modules: _ctx.modules,
      navigation: {
        prevEl: prev.value,
        nextEl: next.value,
      },
      "slides-per-group": 3,
      "slides-per-view": itemsToShow.value,
      "space-between": _ctx.spaceBetween,
      class: "swiper",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click'))),
      onSwiper: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('swiper', $event)))
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slides, (slide, i) => {
          return (_openBlock(), _createBlock(_unref(SwiperSlide), { key: i }, {
            default: _withCtx(() => [
              _createVNode(_component_base_image, {
                "max-width": _ctx.widthItem + 'px',
                src: slide,
                "border-radius": "",
                cover: "",
                height: "70",
                name: "img",
                width: "100%"
              }, null, 8, ["max-width", "src"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["id", "modules", "navigation", "slides-per-view", "space-between"]),
    _createElementVNode("div", {
      ref_key: "next",
      ref: next,
      class: "swiper-button-next"
    }, null, 512)
  ]))
}
}

})